exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  background: #f5f5f5;\n}\nbody #offline-page {\n  margin-top: 50px;\n}\nbody #offline-page .form-signin {\n  max-width: 350px;\n  padding: 19px 29px 29px;\n  margin: 0 auto 20px;\n  background-color: #fff;\n  border: 1px solid #e5e5e5;\n}\nbody #offline-page .form-signin .form-signin-heading,\nbody #offline-page .form-signin .checkbox {\n  margin-bottom: 10px;\n}\nbody #offline-page .form-signin input[type=\"text\"],\nbody #offline-page .form-signin input[type=\"password\"] {\n  font-size: 16px;\n  height: auto;\n  margin-bottom: 15px;\n  padding: 7px 9px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/assets/css/offline.css
// module id = 378
// module chunks = 1